import React, { useEffect, useState } from 'react'

import Modal from 'react-modal'
import { v4 } from 'uuid'
import toast from 'react-hot-toast'

import api from 'Src/api'

import Permissions from '../Permissions'

const USERS_URL = 'v1/users/:id'

const EditUserModal = ({ isOpen, onClose, user }) => {
  const { permissions, id } = user
  const [userPermissions, setUserPermissions] = useState(permissions)
  const [savigPermissions, setSavingPermissions] = useState(false)

  useEffect(() => {
    setUserPermissions(permissions)
  }, [permissions])

  const handleChange = (updatePermissions) => {
    setUserPermissions(updatePermissions)
  }

  const onSave = async () => {
    setSavingPermissions(true)

    const payload = {
      permissions: userPermissions
    }

    const editUserToastId = v4()
    toast.loading('Updating user...', {
      id: editUserToastId
    })

    try {
      await api.patch(USERS_URL, payload, { urlParams: { id } })
      toast.success('Updated user', {
        id: editUserToastId
      })
    } catch (err) {
      toast.error(`Error while updating user - ${err.response.data}`, {
        id: editUserToastId
      })
      console.error('Error while saving permissions', err)
    } finally {
      setSavingPermissions(false)
    }
  }

  return (
    <Modal isOpen={isOpen} contentLabel='Edit User' ariaHideApp={false} onRequestClose={onClose}>
      <div className='modal-header'>
        <h2>Edit User</h2>
        <div className='modal-close' onClick={onClose}>
          &times;
        </div>
      </div>
      <p>
        <span className='font-weight-bold'>Name</span>: {user.name}
      </p>
      <p>
        <span className='font-weight-bold'>Email</span>: {user.email}
      </p>
      {user.invitation_token && (
        <p>
          <span className='font-weight-bold'>Invitation Link</span>: {window.location.origin}/join/
          {user.invitation_token}
        </p>
      )}
      <h4>Permissions</h4>
      <Permissions permissions={userPermissions} onChange={handleChange} />

      <button className='button-primary' type='button' onClick={onSave} disabled={savigPermissions}>
        Save
      </button>
    </Modal>
  )
}

export default EditUserModal
